import { lazy } from 'react';
const OrderItemInquiry = lazy(() => import('./OrderItemInquiry'));

const OrderItemInquiryRoutes = [
  {
    path: '/orderiteminquiry',
    component: OrderItemInquiry
  }
];

export default OrderItemInquiryRoutes;
